import { boxStyleHandlers } from './hooks/use-style-props';

/**
 * Filters out style-related props from the given props object based on the provided style handlers.
 */
export default function filterStyleProps<T extends Record<string, unknown>>(
  props: Record<string, unknown>,
  styleHandlers = boxStyleHandlers,
): T {
  const filteredProps = Object.keys(props).reduce((acc, key) => {
    if (key in styleHandlers) {
      return acc;
    }
    return { ...acc, [key]: props[key] };
  }, {} as T);

  return filteredProps;
}
